import { useState, useEffect } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Header from "../../components/Header";
import InitialConfigs from "./InitialConfigs";
import Box from "@mui/material/Box";
import ShaftSelection from "./ShaftSelection";
import HeadSelection from "./HeadSelection";
import BallSelection from "./BallSelection";
import Divider from "@mui/material/Divider";
import EndSession from "./EndSession";
import WebSocketConnection from "../../utils/WebSocketConnection";

const Fitting = () => {
	const [step, setStep] = useState(0);
	const [trackAtStart, setTrackAtStart] = useState(true);
	const [clubType, setClubType] = useState(localStorage.getItem("clubType") || "Drivers");

	// Update club type when localStorage changes
	useEffect(() => {
		const handleStorageChange = () => {
			setClubType(localStorage.getItem("clubType") || "Drivers");
		};
		window.addEventListener("storage", handleStorageChange);
		return () => window.removeEventListener("storage", handleStorageChange);
	}, []);

	// Check if current club type should show ball selection
	const showBallSelection = clubType === "Drivers" || clubType === "Irons";

	// Generate steps dynamically based on club type
	const steps = showBallSelection
		? [
				"Initial Configuration",
				"Shaft Selection",
				"Head Selection",
				"Ball Selection",
				"End Fitting",
		  ]
		: [
				"Initial Configuration",
				"Shaft Selection",
				"Head Selection",
				"End Fitting",
		  ];

	const increaseStep = () => {
		if (step === 0) {
			setTrackAtStart(true);
			// Update club type when leaving initial config
			setClubType(localStorage.getItem("clubType") || "Drivers");
		}
		setStep(step + 1);
	};
	const decreaseStep = () => {
		const ballStepIndex = showBallSelection ? 3 : -1;
		if (step === ballStepIndex) {
			setTrackAtStart(false);
		}
		setStep(step - 1);
	};
	return (
		<Header>
			<Stepper activeStep={step} sx={{ margin: 2 }}>
				{steps.map((label, index) => {
					return (
						<Step key={label}>
							<StepButton
								color="inherit"
								onClick={() => {
									setStep(index);
									WebSocketConnection.captureData = false;
									WebSocketConnection.clearGatheredData();
								}}
							>
								{label}
							</StepButton>
						</Step>
					);
				})}
			</Stepper>
			<Divider />
			<Box sx={{ margin: 2 }}>
				{step === 0 ? (
					<InitialConfigs increaseStep={increaseStep} />
				) : step === 1 ? (
					<ShaftSelection
						increaseStep={increaseStep}
						decreaseStep={decreaseStep}
						trackAtStart={trackAtStart}
						currentStep={step}
					/>
				) : step === 2 ? (
					<HeadSelection
						increaseStep={increaseStep}
						decreaseStep={decreaseStep}
						currentStep={step}
					/>
				) : showBallSelection && step === 3 ? (
					<BallSelection
						increaseStep={increaseStep}
						decreaseStep={decreaseStep}
						currentStep={step}
					/>
				) : (
					<EndSession />
				)}
			</Box>
		</Header>
	);
};

export default Fitting;
